import { Link } from "react-router-dom";

interface FreshTileProps {
  to: string;
  title: string;
  subtitle?: string;
  imageUrl?: string | null;
}

/**
 * Fresh catalog tile: photo + title + subtitle. Falls back to a
 * gradient panel with the first two letters of the title when the
 * image is missing or fails to load.
 */
export function FreshTile({ to, title, subtitle, imageUrl }: FreshTileProps) {
  const initials = title.slice(0, 2).toUpperCase();
  return (
    <Link to={to} className="fresh-tile">
      <div className="fresh-tile-img">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            loading="lazy"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).style.display = "none";
            }}
          />
        ) : null}
        {!imageUrl && (
          <div className="fresh-tile-fallback">{initials}</div>
        )}
      </div>
      <div className="fresh-tile-body">
        <div className="fresh-tile-title">{title}</div>
        {subtitle && (
          <div className="fresh-tile-sub">
            <span className="fresh-tile-sub-dot" />
            <span>{subtitle}</span>
          </div>
        )}
      </div>
    </Link>
  );
}
